import { ICellRendererParams, IHeader } from '@ag-grid-community/core';

export type ClearAllHeaderRendererParams = ICellRendererParams & {
  clearAllHandler: () => void;
};

export class ClearAllHeaderRenderer implements IHeader {
  private params: ClearAllHeaderRendererParams;
  private eGui: HTMLElement;
  private button: HTMLElement;

  init(params: ClearAllHeaderRendererParams) {
    this.params = params;
    this.render();
  }

  getGui() {
    return this.eGui;
  }

  onColumnResized() {
    // Not needed for this implementation
  }

  refresh(): boolean {
    return true;
  }

  private render(): void {
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.justifyContent = 'center';
    this.eGui.style.height = '100%';
    this.eGui.style.width = '100%';

    const button = document.createElement('img');
    button.setAttribute('src', '/deal-icons/eraser.svg');
    button.style.height = '14px';
    button.style.cursor = 'pointer';
    button.title = 'Clear All Draft Orders';
    button.addEventListener('click', () => {
      this.params.clearAllHandler();
    });
    this.button = button;

    this.eGui.append(button);
  }
}
